import React, { Component } from "react";
import { Edit, PlusCircle } from "react-feather";
import Pagination from "../../../../components/Pagination";

export default class Table extends Component {
  render() {
    const {
      changeMode,
      onSearch,
      data,
      loading,
      onEdit,
      currentPage,
      onPageChange,
    } = this.props;
    
    return (
      <div>
        <div className="row">
          <div className="col-sm-8">
            <button
              className="btn btn-teal btn-sm font-weight-bold"
              onClick={() => changeMode("add")}
            >
              <PlusCircle className="mr-2" />
              Tambah Data
            </button>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control bg-light"
                placeholder="Cari berdasarkan Focus ID"
                onChange={(e) => onSearch(e)}
              />
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Aksi</th>
                <th>Kelurahan/Desa</th>
                <th>ID Fokus</th>
                <th>Nama Dusun</th>
                <th>Jumlah Penduduk</th>
                <th>Jumlah Rumah</th>
              </tr>
            </thead>
            <tbody>
              {!loading && data && data.pe_focuses &&
                data.pe_focuses.length > 0 ?
                data.pe_focuses.map((item) => {
                  return (
                    <tr key={item.id}>
                      <td className="text-center">
                        <button
                          className="btn btn-edit btn-sm font-weight-bold"
                          onClick={() => onEdit(item)}
                          style={{ cursor: "pointer" }}
                        >
                          <Edit size={15} /> Edit
                        </button>
                      </td>
                      <td className="text-capitalize">
                        {item.urbanvillage_id}
                      </td>
                      <td className="text-capitalize">
                        {item.focus_id}
                      </td>
                      <td className="text-capitalize">
                        {item.sub_village}
                      </td>
                      <td className="text-capitalize">
                        {item.number_of_residents}
                      </td>
                      <td className="text-capitalize">
                        {item.number_of_houses}
                      </td>
                    </tr>
                  );
                })
                :
                <tr>
                  <td colSpan={20} className="text-center font-weight-bold">
                    {loading ? (
                      "loading..."
                    ) :
                      "No Data"
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div className="row">
            <div className="col-sm-12 col-md-5">
              {`Showing ${data.limit === "undefined" ? 0 : data.limit} of 
              ${data.total === "undefined" ? 0 : data.total} Data`}
            </div>
            <div className="col-sm-12 col-md-7">
              {!loading &&
              <Pagination
                style={{ float: "right", marginLeft: 10 }}
                totalRecords={data.total}
                pageLimit={data.limit}
                pageNeighbours={2}
                currentPage={currentPage}
                onPageChange={(page, limit) => onPageChange(page, limit)}
              />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
